import { useQuery } from "react-query";
import BreadcrumbComponent from "../../components/BreadcrumbComponent/BreadcrumbComponent";
import globals from "../../config/appconfig";
import { BREADCRUMB_ARCHIVIO_RSSR } from "../../utils/BreadcrumbEnums";
import "./ArchivioRSSR.scss";
import waferssServices from "../../hooks/waferssServices";
import { Helmet } from "react-helmet";
import { APP_NAME } from "../../utils/Constans";
import AnniRelazione from "../../utils/AnniRelazione";


const TITOLO_RELAZIONE_SS =  "Relazione Socio Sanitaria della Regione del Veneto";

/**
 * @function ArchivioRSSR page rendering the achivi RSSR
 * @returns {JSX.Element}
*/

const ArchivioRSSR = () => {
    const dowloadPdf = (file) => {
        window.open(`${globals["app-url-bucket"]}${file}`);
    }

    const { getArchiviRSSR } = waferssServices();

    const { data: ArchiviRSSR } = useQuery(["ArchiviRSSR"], () => getArchiviRSSR({ "anteprima": false }), {
        refetchOnWindowFocus: false
    });

    return (
        <div className="ArchivioRSSR">
            <BreadcrumbComponent items={BREADCRUMB_ARCHIVIO_RSSR}></BreadcrumbComponent>
            <Helmet>
                <title>{APP_NAME} | Archivio Relazioni Socio Sanitarie della Regione del Veneto</title>
            </Helmet>
            <div className="ArchivioRSSR__title mb-5">
                <h1>Archivio Relazioni Socio Sanitarie della Regione del Veneto</h1>
            </div>
            {(ArchiviRSSR?.data?.length) ?
                <div className="ArchivioRSSR__timeLine">
                    { ArchiviRSSR?.data?.map(item => {
                        let descrizioneFile = AnniRelazione.find(archivi => archivi.anno === item?.anno)?.descrizioneFile;
                        return (
                            <div key={item} className="col-12 col-md-12 col-lg-12 col-xl-10 ArchivioRSSR__timeLine--item">
                                <div className="row">
                                    <div className="col-6 col-md-2 col-lg-3 col-xl-2">
                                        <div className="d-flex justify-content-between">
                                            <div className="font-size-24 fw-600">{item?.anno}</div>
                                            <div className="ArchivioRSSR__timeLine--item--pin-icon align-self-center">
                                                <div className="ArchivioRSSR__timeLine--item--riga"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-10 col-lg-2 col-xl-4">
                                        <div className="font-size-24 fw-600">{TITOLO_RELAZIONE_SS}</div>
                                        <div className="font-size-20 ArchivioRSSR__timeLine--item--dati">{ descrizioneFile }</div>
                                    </div>
                                    <div className="col-6 offset-6 col-md-10 offset-md-2 col-lg-3 offset-lg-0 offset-xl-0 col-xl-3" onClick={() => dowloadPdf(item?.file)}>
                                        <a className="custom-link">
                                            <div className="d-flex">
                                                <span className="material-icons-outlined" aria-hidden="true">file_download</span>
                                                <div>Download PDF</div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-6 offset-6 col-md-10 offset-md-2 col-lg-2 offset-lg-0 offset-xl-0 col-xl-2 mt-1 font-size-14 ArchivioRSSR__timeLine--item--dati">{`[${item?.dimensione}]`}</div>
                                </div>
                            </div>
                        )
                    })}
                </div> : <div>Non ci sono Archivio Relazioni Socio Sanitarie della Regione del Veneto</div>}
        </div>
    )

};

ArchivioRSSR.propTypes = {};

ArchivioRSSR.defaultProps = {};

export default ArchivioRSSR;